module.exports = __webpack_public_path__ + "media/images/pic/anime/monument-f92ca001f5aea457567cd302558e9355.png";